<div class="photos">
  <div class="upload-images upload-images-container">
    <div class="upload-images__item">
      <div class="upload-images__item-wrapper">
        <div class="upload-images__title" [innerHtml]="'PROJECT.image_before' | translate"></div>
        <div class="upload-images__bar">
          <span class="">{{ 'PROJECT.only_one_image' | translate }}</span>
          <div class="upload-images__helper">
            <button class="btn btn--link" (click)="displayBeforeImageHelpModal = true">
              {{ 'PROJECT.help' | translate }}
            </button>

            <p-dialog
              [(visible)]="displayBeforeImageHelpModal"
              [dismissableMask]="true"
              [modal]="true"
              (onHide)="displayBeforeImageHelpModal = false"
            >
              <div style="padding: 40px 80px">
                <div class="modal__wrapper modal__wrapper--xlg">
                  <div class="photos-helper">
                    <div class="photos-helper__title">
                      {{ 'PROJECT.create_before_title' | translate }}
                    </div>
                    <div class="photos-helper__content">
                      <div class="photos-helper__description">
                        {{ 'PROJECT.create_before_desc' | translate }}
                      </div>
                      <div class="photos-helper__image">
                        <img src="assets/img/create_before.webp" alt="Image" />
                      </div>
                    </div>
                  </div>
                  <div class="modal__actions">
                    <button
                      class="btn btn--outline btn--primary btn--xs btn--rounded"
                      (click)="displayBeforeImageHelpModal = false"
                    >
                      {{ 'GLOBAL.ok' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </p-dialog>
          </div>
        </div>
      </div>
      <app-ph-upload
        [required]="true"
        [correctForm]="correctForm"
        [formDataFile]="true"
        name="beforeImg"
        [checkTags]="true"
        #beforeImg
        (phUploadErrorOptions)="catchMapError($event)"
        (phUploadSuccess)="addToCropper($event)"
        (phUploadSuccessOptions)="setElementsFromImageTags($event, 'map', beforeImg)"
        styletype="gray"
      ></app-ph-upload>
    </div>
    <div class="upload-images__item">
      <div class="upload-images__item-wrapper">
        <div class="upload-images__title" [innerHtml]="'PROJECT.image_after' | translate"></div>
        <div class="upload-images__bar">
          <span class="">{{ 'PROJECT.image_with_tag' | translate }}</span>
          <div class="upload-images__helper">
            <button class="btn btn--link" (click)="displayAfterImageHelpModal = true">
              {{ 'PROJECT.help' | translate }}
            </button>

            <p-dialog
              [(visible)]="displayAfterImageHelpModal"
              [dismissableMask]="true"
              [modal]="true"
              (onHide)="displayAfterImageHelpModal = false"
            >
              <div style="padding: 40px 80px">
                <div class="modal__wrapper modal__wrapper--xlg">
                  <div class="photos-helper">
                    <div class="photos-helper__title">
                      {{ 'PROJECT.create_after_title' | translate }}
                    </div>
                    <div class="photos-helper__content">
                      <div class="photos-helper__description">
                        {{ 'PROJECT.create_after_desc' | translate }}
                      </div>
                      <div class="photos-helper__image">
                        <img src="assets/img/create_after.webp" alt="Image" />
                      </div>
                    </div>
                  </div>
                  <div class="modal__actions">
                    <button
                      class="btn btn--outline btn--primary btn--xs btn--rounded"
                      (click)="displayAfterImageHelpModal = false"
                    >
                      {{ 'GLOBAL.ok' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </p-dialog>
          </div>
        </div>
      </div>
      <app-ph-upload
        [required]="true"
        [correctForm]="correctForm"
        [formDataFile]="true"
        [checkTags]="true"
        #afterImg
        (phUploadSuccess)="addToCropper($event)"
        (phUploadSuccessOptions)="setElementsFromImageTags($event, 'none', afterImg)"
        name="afterImg"
        styletype="gray"
      ></app-ph-upload>
    </div>
    <div class="upload-images__item">
      <div class="upload-images__item-wrapper">
        <div
          class="upload-images__title"
          [innerHTML]="'PROJECT.images_where_leave_trash' | translate"
        >
          <span class="text--danger">*</span>
        </div>
        <div class="upload-images__bar">
          <span class="">{{ 'PROJECT.only_one_image' | translate }}</span>
          <div class="upload-images__helper">
            <button class="btn btn--link" (click)="displayDisposedImageHelpModal = true">
              {{ 'PROJECT.help' | translate }}
            </button>

            <p-dialog
              [(visible)]="displayDisposedImageHelpModal"
              [dismissableMask]="true"
              [modal]="true"
              (onHide)="displayDisposedImageHelpModal = false"
            >
              <div style="padding: 40px 80px">
                <div class="modal__wrapper modal__wrapper--xlg">
                  <div class="photos-helper">
                    <div class="photos-helper__title">
                      {{ 'PROJECT.create_disposed_title' | translate }}
                    </div>
                    <div class="photos-helper__content">
                      <div class="photos-helper__description">
                        {{ 'PROJECT.create_disposed_desc' | translate }}
                      </div>
                      <div class="photos-helper__image">
                        <img src="assets/img/create_disposed.webp" alt="Image" />
                      </div>
                    </div>
                  </div>
                  <div class="modal__actions">
                    <button
                      class="btn btn--outline btn--primary btn--xs btn--rounded"
                      (click)="displayDisposedImageHelpModal = false"
                    >
                      {{ 'GLOBAL.ok' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </p-dialog>
          </div>
        </div>
      </div>
      <app-ph-upload
        [required]="true"
        [correctForm]="correctForm"
        [formDataFile]="true"
        (phUploadSuccess)="addToCropper($event)"
        #leaveTrashImg
        [checkTags]="true"
        name="leaveTrashImg"
        (phUploadSuccessOptions)="setElementsFromImageTags($event, 'date', leaveTrashImg)"
        styletype="gray"
      ></app-ph-upload>
    </div>
    <div class="upload-images__item upload-images__item--multiple">
      <div class="upload-images__item-wrapper">
        <div class="upload-images__title">{{ 'PROJECT.additional_images' | translate }}</div>
        <div class="upload-images__bar">
          <span class="">{{ 'PROJECT.up_to_five_images' | translate }}</span>
        </div>
      </div>
      <div class="upload-images__inputs">
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          name="additionalImg1"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg1
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          name="additionalImg2"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg2
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          name="additionalImg3"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg3
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          name="additionalImg4"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg4
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          name="additionalImg5"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg5
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(6) }"
          name="additionalImg6"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg6
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(7) }"
          name="additionalImg7"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg7
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(8) }"
          name="additionalImg8"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg8
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(9) }"
          name="additionalImg9"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg9
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(10) }"
          name="additionalImg10"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg10
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(11) }"
          name="additionalImg11"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg11
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(12) }"
          name="additionalImg12"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg12
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(13) }"
          name="additionalImg13"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg13
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(14) }"
          name="additionalImg14"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg14
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(15) }"
          name="additionalImg15"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg15
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(16) }"
          name="additionalImg16"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg16
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(17) }"
          name="additionalImg17"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg17
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(18) }"
          name="additionalImg18"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg18
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(19) }"
          name="additionalImg19"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg19
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(20) }"
          name="additionalImg20"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg20
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(21) }"
          name="additionalImg21"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg21
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(22) }"
          name="additionalImg22"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg22
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(23) }"
          name="additionalImg23"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg23
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(24) }"
          name="additionalImg24"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg24
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(25) }"
          name="additionalImg25"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg25
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(26) }"
          name="additionalImg26"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg26
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(27) }"
          name="additionalImg27"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg27
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(28) }"
          name="additionalImg28"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg28
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(29) }"
          name="additionalImg29"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg29
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(30) }"
          name="additionalImg30"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg30
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(31) }"
          name="additionalImg31"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg31
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(32) }"
          name="additionalImg32"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg32
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(33) }"
          name="additionalImg33"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg33
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(34) }"
          name="additionalImg34"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg34
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(35) }"
          name="additionalImg35"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg35
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(36) }"
          name="additionalImg36"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg36
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(37) }"
          name="additionalImg37"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg37
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(38) }"
          name="additionalImg38"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg38
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(39) }"
          name="additionalImg39"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg39
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(40) }"
          name="additionalImg40"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg40
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(41) }"
          name="additionalImg41"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg41
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(42) }"
          name="additionalImg42"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg42
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(43) }"
          name="additionalImg43"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg43
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(44) }"
          name="additionalImg44"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg44
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(45) }"
          name="additionalImg45"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg45
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(46) }"
          name="additionalImg46"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg46
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(47) }"
          name="additionalImg47"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg47
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(48) }"
          name="additionalImg48"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg48
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(49) }"
          name="additionalImg49"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg49
          styletype="gray"
        ></app-ph-upload>
        <app-ph-upload
          [correctForm]="correctForm"
          [formDataFile]="true"
          [checkTags]="true"
          [requiredTags]="false"
          [ngClass]="{ hidden: activeInput(50) }"
          name="additionalImg50"
          (phUploadSuccess)="addToCropper($event)"
          (phUploadSuccessOptions)="setElementsFromImageTags($event)"
          #additionalImg50
          styletype="gray"
        ></app-ph-upload>
        <div class="next-photo" (click)="showNextInput()" *ngIf="showNextButton">
          {{ 'PROJECT.plus_one' | translate }}
        </div>
      </div>
    </div>
  </div>
  <div class="project__map">
    <div class="project__map-title">{{ 'PROJECT.show_us_where_is_was' | translate }}</div>
    <app-open-street-map-with-marker
        #openStreetMap
        [updatePositionOnMapClick]="photosChangeMapOnClick"
        [markerDraggable]="photosMarkerDraggable"
        [form]="correctFormDesc"
    ></app-open-street-map-with-marker>
  </div>
  <app-ph-cropper #phCropper (phCropperChange)="findCorrectPhUpload($event)"></app-ph-cropper>
</div>
